import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";

const ClubPage = lazy(() => import("@/pages/ClubPage"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const ThankYouPage = lazy(() => import("@/pages/ThankYouPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ErrorBoundary>
        <Suspense fallback={<div className="min-h-screen bg-[#1A1A1A]" />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/clube/:clubId" element={<ClubPage />} />
            <Route path="/club/:clubId" element={<ClubPage />} />
            <Route path="/campanha-ginasio" element={<HomePage />} />
            <Route path="/promocao-ginasio" element={<HomePage />} />
            <Route path="/ginasio-maia" element={<Navigate to="/clube/maia" replace />} />
            <Route path="/ginasio-barcelos" element={<Navigate to="/clube/barcelos" replace />} />
            <Route path="/personal-trainer-maia" element={<Navigate to="/clube/maia" replace />} />
            <Route path="/personal-trainer-barcelos" element={<Navigate to="/clube/barcelos" replace />} />
            <Route path="/aulas-grupo-maia" element={<Navigate to="/clube/maia" replace />} />
            <Route path="/aulas-grupo-barcelos" element={<Navigate to="/clube/barcelos" replace />} />
            <Route path="/perda-peso-maia" element={<Navigate to="/clube/maia" replace />} />
            <Route path="/perda-peso-barcelos" element={<Navigate to="/clube/barcelos" replace />} />
            <Route path="/obrigado-maia" element={<ThankYouPage clubId="maia" />} />
            <Route path="/obrigado-barcelos" element={<ThankYouPage clubId="barcelos" />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/terms" element={<LegalPage type="terms" />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
      <CookieConsent />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            color: '#111827',
            border: '1px solid #E5E7EB',
          },
        }}
      />
    </div>
  );
}

export default App;
